import React, { useState, useEffect } from "react";
import TotalInternship from "./TotalInternship";
import MaintenancePage from "../../../pages/mainsidebar/Maintenancepage";
import ElegantCarousel from "../../../pages/Trainer FDP/Example/ElegantCarousel";
import SigningAuthorityNotification from "./SigningAuthorityNotification";

const InternshipSection = () => {
  const [showCarousel, setShowCarousel] = useState(false);
  const [showNotification, setShowNotification] = useState(true);

  useEffect(() => {
    // Check session storage instead of cookie
    const hasViewedCarousel = sessionStorage.getItem("carouselViewed");
    if (!hasViewedCarousel) {
      setShowCarousel(true);
      sessionStorage.setItem("carouselViewed", "true");
    }
  }, []);

  const handleCloseCarousel = () => {
    setShowCarousel(false);
  };

  const handleYes = () => {
    console.log("User is the Signing Authority");
    setShowNotification(false);
    // Add your logic here (e.g., set cookie, update state, etc.)
  };

  const handleNo = () => {
    console.log("User is NOT the Signing Authority");
    setShowNotification(false);
    // Add your logic here
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  return (
    <>
      {showNotification && (
        <SigningAuthorityNotification
          onYes={handleYes}
          onNo={handleNo}
          onClose={handleCloseNotification}
        />
      )}
      {showCarousel && <ElegantCarousel onClose={handleCloseCarousel} />}
      <TotalInternship />
      {/* <MaintenancePage /> */}
    </>
  );
};

export default InternshipSection;
